<template>
  <div class="editableContainter">
    <div class="topContainer">
    <audio-player :audioUri="data.audioUri" ref='audio'></audio-player>
    </div>
    <div v-if='isLoading' class="leftContainer mask">
      <div class="loading"></div>
    </div>
    <div v-if='!isLoading' class="leftContainer">

      <b-modal class="filter-modal" :active.sync="isTextEditPopupActive" has-modal-card>
          <TextEditPopup  ref="texteditpopup" v-bind:style="{top:formProps.top,left:formProps.left}" v-bind="formProps" @popupChange="onTextEditPopupChanged"></TextEditPopup>
      </b-modal>

      <b-modal class="filter-modal" :active.sync="isHighlightModalActive" has-modal-card>
          <HighlightPopup v-bind:style="{ top:filterModalPosition.top, bottom: filterModalPosition.bottom, left: filterModalPosition.left, right: filterModalPosition.right}"  v-bind="linkDialogProps" :dialogStyle="filterModalPosition" @addNewItem="onAddNewItem" @tagClicked="onTagClicked"></HighlightPopup>
      </b-modal>
      
      <TranscriptionContent :transcriptId="transcriptId" @click="showTextEditPopup" @dragClick="showAnnotatePopup" @doubleClick="playAudio" @updateTokens="onTokensUpdate"/>
    </div>

    <div class="rightContainer">
      <ModalWithDeleteCard v-bind:config="tagCardConfig"/>
      <ModalWithDeleteCard v-bind:config="resourceCardConfig"/>
      <ModalWithDeleteCard v-bind:config="segmentCardConfig"/>
      <Questions :values="questions"/>

      <button class="button is-success" style="height:50px;font-size:20px!important" @click="onSubmit()"> 
            Save
      </button>
    </div>

  <ConfirmationDialog ref="confirmDialog" :config="confirmationConfig"/>

  </div>
</template>

<script>
import TextEditPopup from '../components/TextEditPopup';
import TranscriptionContent from '../components/TranscriptionContent';
import Highlighter from 'vue-highlight-words';
import ModalWithDeleteCard from '../components/ModalWithDeleteCard'
import Questions from '../components/Questions'
import HighlightPopup from '../components/HighlightPopup'
import AudioPlayer from '../components/AudioPlayer'
import ConfirmationDialog from '../components/ConfirmationDialog'
import PatientService from '../services/patientService'



const contextSpacing = 0;

export default {
  components: {
      TextEditPopup,
      Highlighter,
      ModalWithDeleteCard,
      Questions,
      HighlightPopup,
      PatientService,
      AudioPlayer,
      TranscriptionContent,
      ConfirmationDialog
  },
  name: 'detail',
  props: {
  },
  data() {
    return{
      selectedTag: 'Please Select',
      customResource: '',
      isLoading: true,
      changes: false, 
      clicks: 0,
      timer: null,
      name:this.$route.params.id,
      isTextEditPopupActive: false,
      isHighlightModalActive: false,
      isConfirmToLeave: false,
      confirmationConfig: {
        text: 'You have unsaved changes, leave this page?',
        trueButtonText: 'Leave',
        falseButtonText: 'Stay'
      },
      filterModalPosition: {
        top: 'inherit',
        bottom: 'inherit',
        left: 'inherit',
        right: 'inherit',
        position: 'relative'
      },
      formProps: {
          edit: '',
          index: 0,
          top: 'inherit',
          left: 'inherit'
      },
      linkDialogProps: {
        selectionText:'',
        start:0,
        end:0
      }
    }
  },
  methods:{
    handleEvent (evt) {
      if (evt.type === 'mouseup' && (evt.target.nodeName === "DIV" || evt.target.nodeName === "P")) {
        this.$store.commit('selectionTextSet','')
      }
    },
    onTextEditPopupChanged(value,index){
      const me = this;

      me.changes = true;
      me.$store.commit('commitPatientContextToken',{word:value, index:index, transcriptId: me.transcriptId})
    },
    onTextEditPopupBlurred(){
      this.isTextEditPopupActive = false;
    },

    onAddNewItem (item){
      const me = this;
      var newItem = {id:item.id, value:item.value, type: item.type, createdFor:me.patientId};
      
      me.changes = true;
      me.$store.dispatch('addNewTypeItem',newItem);
      me.$store.commit('addTagItem',{transcriptId: me.transcriptId, value:item.value, selectionText: me.linkDialogProps.selectionText, type:item.type, id:item.id, start: me.linkDialogProps.start, end:me.linkDialogProps.end})
      me.$store.commit('selectionTextSet','');
    },
    onTagClicked(item){
      const me = this;

      me.changes = true;
      me.$store.commit('addTagItem',item);
      me.$store.commit('selectionTextSet','');
    },
    onTokensUpdate(detail){
      const me = this;

      me.changes = true;
      me.$store.commit('updateToken',detail);
    },
    showAnnotatePopup(highlightInfo){
      var me = this;
      me.isHighlightModalActive = highlightInfo.isHighlightModalActive
      me.linkDialogProps.selectionText = highlightInfo.linkDialogProps.selectionText
      me.linkDialogProps.start = highlightInfo.linkDialogProps.start ;
      me.linkDialogProps.end = highlightInfo.linkDialogProps.end ;
      me.filterModalPosition.top =  highlightInfo.filterModalPosition.top ;
      me.filterModalPosition.left = highlightInfo.filterModalPosition.left ;
    },
    showTextEditPopup(formValue){
      var me = this;
      me.formProps.edit = formValue.edit
      me.formProps.index = formValue.index
      me.formProps.top = formValue.top;
      me.formProps.left = formValue.left;
      me.isTextEditPopupActive = true;
      setTimeout(function() {
        me.$refs.texteditpopup.$el.children[0].focus();
      }, 100);
    },
    playAudio(){
      const me = this;
      let startPlayTokenIndex = me.getClickTokenIndex();
      let endIndex = startPlayTokenIndex >= 0 && startPlayTokenIndex < me.data.tokens.length ? startPlayTokenIndex + 10 : 0;
      let startTime = me.data.tokens[startPlayTokenIndex].startTime - startPlayTokenIndex*0.0065 < 0 ? 0 : me.data.tokens[startPlayTokenIndex].startTime - startPlayTokenIndex*0.0065;
      let time = me.data.tokens[endIndex].endTime - startTime;

      me.$refs.audio.playAudio(startTime,time);
    },
    getClickTokenIndex() {
      var s = window.getSelection();
      var index = -1;
      var rawHtml = this.rawHtml.trim();
      var total = 0;
      var num = ((rawHtml.substr(0, s.anchorOffset)).split('ÿ')).length - 1;

        for (var i = 0; i < this.data.tokens.length; i++) {
            total = total + this.data.tokens[i].word.length;
            if (total >= (s.anchorOffset - num - contextSpacing)) {
                index = i;
                break;
            }
        }

      return index;
    },
    onSubmit(){
      const me = this;

      me.$store.dispatch('submitTranscript',me.transcriptId).then(function(){
        me.changes = false;
        me.$store.commit('setNotification',{state:'success',text:'Data saved.'});
      }).catch(function(){
        me.$store.commit('setNotification',{state:'error',text:'Error saving.'});
      });
    },
    confirmExit()
    {
      return "You have attempted to leave this page.  If you have made any changes to the fields without clicking the Save button, your changes will be lost.  Are you sure you want to exit this page?";
    }
  },

  computed: {
    data() {
      const me = this;
      let patient = me.$store.state.patients.find(function(pTranscript){
        return pTranscript.transcriptId === me.transcriptId;
        });

      me.$store.state.modalWithDeleteItems[0].items = patient.transcript.tags || [];
      me.$store.state.modalWithDeleteItems[1].items = patient.transcript.resources || [];
      me.$store.state.modalWithDeleteItems[2].items = patient.transcript.segments || [];

      return patient.transcript
    },
    transcriptId(){
      return this.$route.params.transcript.transcriptId
    },
    patientId(){
        return this.$route.params.transcript.patientId;
    },
    questions(){
      return this.$route.params.transcript.questions
    },
    tagCardConfig() {
      return {
        class: 'tag-container',
        label: 'Tags',
        type: this.LinkType.Tag
      }
    },
    resourceCardConfig(){
      return {
        class: 'resource-container',
        label: 'Resources',
        type: this.LinkType.Resource
      }
    },
    segmentCardConfig() {
      return {
        class: 'segment-container',
        label: 'Segments',
        type: this.LinkType.Segment
      }
    },
    rawHtml () {
      return this.$store.state.rawHtml
    }
  },
  async mounted() {
    var me = this;

    me.isLoading = false;
    window.onbeforeunload = me.confirmExit;
  },
  async beforeRouteLeave (to, from , next) {
    const me = this;
    
    if(me.changes){
      next(await me.$refs.confirmDialog.open()); 
    }
    else{
      next();
    }
}

}
</script>

<style>
.my-highlight {
  font-weight: 400;
  font-family: Akkurat Std,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Helvetica Neue,sans-serif;
}

.editableContainter {
    overflow:auto;
    height: calc(100vh - 130px);
}

.topContainer{
    width: calc(70% - 40px);
    text-align: left;
    margin-left: 2%;
    border-radius: 5px;
    display: -webkit-box;
    display: -ms-flexbox;
}

.leftContainer{
  position: relative;
  width: calc(70% - 40px);
  float: left;
  padding:20px;
  text-align: left;
  margin-left:2%;
  box-shadow: 1px 1px 20px lightgray;
  background:white;
  border-radius: 5px;
  min-height: 400px;
}

.rightContainer {
    width: calc(30% - 20px);
    float: right;
    padding: 0px 20px 20px 20px;
    height:inherit;
}

.mask{
  background: whitesmoke;
}

.loading {
  position: absolute;
  left: 52%;
  top: 55%;
  margin: -60px 0 0 -60px;
  background: whitesmoke;
  width: 50px;
  height: 50px;
  border-radius: 100%;
  border: 2px solid rgb(43,183,252) ;
  box-shadow: 0px 0px 4px rgba(43,183,252,0.6);
}
.loading:after {
  content: '';
  background: trasparent;
  width: 140%;
  height: 140%;
  position: absolute;
  border-radius: 100%;
  top: -20%;
  left: -20%;
  opacity: 0.7;
  box-shadow: rgba(43,183,252,0.6) -4px -5px 3px -3px;
  animation: rotate 0.4s infinite linear;
}

@keyframes rotate {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
.filter-modal.modal{
    -webkit-box-align: baseline!important;
    -ms-flex-align: baseline!important;
    align-items: baseline!important;
    -webkit-box-pack: start!important;
    -ms-flex-pack: inherit!important;
    justify-content: inherit!important;
    text-align: left;
}
.filter-modal.modal .modal-background{
    opacity:0;
}
.filter-modal .animation-content{
    max-width:inherit!important;
    height:170px;
    width:300px;
    margin: 0 20px;
    position: absolute;
    top: 0;
    left: 0;
}
</style>